if (!customElements.get('product-gallery-component')) {
  customElements.define(
    'product-gallery-component',
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.setData();
        this.setupSliderGallery();
        if (this.thumbnail) {
          this.setupSliderThumbnail();
        }
      }

      setData() {
        this.gallery = this.querySelector('[data-product-gallery]');
        this.galleryCarousel = this.gallery.querySelector('[data-carousel-container]');
        this.thumbnail = this.querySelector('[data-gallery-thumbnail]');

        this.layout = this.dataset.galleryLayout;
        this.layoutMobile = this.dataset.galleryMobileLayout;
        this.thumbnailsView = 5;

        if (this.thumbnail) {
          this.thumbnailCarousel = this.thumbnail.querySelector('[data-carousel-container]');
          this.position = this.thumbnail.dataset.position;
        }
      }

      setupSliderGallery() {
        // if (this.galleryInstance) return;
        const galleryList = this.gallery.querySelectorAll('[data-carousel-item]');
        this.numImages = galleryList.length;
        const enabledDesktop = this.layout == 'slider';
        let enabledMobile = true;
        if (this.layout != 'slider' && this.layoutMobile == 'default') {
          enabledMobile = false;
        }
        // Initialize gallery slider
        this.galleryInstance = new Swiper((this.galleryCarousel), {
          init: false,
          slidesPerView: 1,
          centeredSlides: false,
          loop: this.numImages > 1,
          loopedSlides: this.numImages,
          direction: 'horizontal',
          preloadImages: false,
          spaceBetween: 15,
          navigation: {
            nextEl: this.gallery.querySelector('[data-carousel-nav-next]'),
            prevEl: this.gallery.querySelector('[data-carousel-nav-prev]'),
          },
          pagination: {
            el: this.gallery.querySelector('[data-carousel-pagination]'),
            clickable: true,
            modifierClass: 'swiper-pagination-',
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            currentClass: 'swiper-pagination-current',
            totalClass: 'swiper-pagination-total',
            hiddenClass: 'swiper-pagination-hidden',
          },
          // enabled: enabledMobile,
          // breakpoints: {
          //   768: {
          //     enabled: enabledDesktop,
          //   }
          // },
        });
        
        this.galleryInstance.init();
  
        this.galleryInstance.on('slideChangeTransitionStart', () => {
          window.pauseAllMedia();
          this.galleryInstance.allowTouchMove = true;
        });
        this.galleryInstance.on('slideChangeTransitionEnd', () => {
          const activeItem = this.gallery.querySelectorAll('[data-carousel-item]')[this.galleryInstance.activeIndex];
          this.playActiveMedia(activeItem);
          if (this.thumbnailInstance) this.setActiveThumbnail(activeItem.dataset.swiperSlideIndex);
        });
      }

      setupSliderThumbnail() {
        let direction = 'vertical';
        if (this.position == 'bottom') {
          direction = 'horizontal';
          this.thumbnailsView = 9;
        }
        const thumbnailList = this.thumbnail.querySelectorAll('[data-carousel-item]');
        
        this.thumbnailInstance = new Swiper((this.thumbnailCarousel), {
          init: false,
          slidesPerView: this.thumbnailsView,
          loop: this.numImages > this.thumbnailsView,
          loopedSlides: this.numImages,
          spaceBetween: 15,
          direction: direction,
          slidesOffsetBefore: 0,
          centeredSlides: false,
          slideToClickedSlide: true,
          navigation: {
            nextEl: this.thumbnail.querySelector('[data-carousel-nav-next]'),
            prevEl: this.thumbnail.querySelector('[data-carousel-nav-prev]'),
          },
        });

        // Set height to thumbnail slider
        const thumbnailRender = () => {
          const image = this.thumbnail.querySelector('[data-carousel-item] img');
          if (image) {
            const space = 15;
            const wrapperHeight = ((image.offsetHeight + space) * this.thumbnailsView) - space;
            this.thumbnailCarousel.style.maxHeight = `${wrapperHeight}px`;
          }
          // this.thumbnailInstance.update();
        };
        this.thumbnailInstance.on('resize', () => {
          thumbnailRender();
        });
        this.thumbnailInstance.on('init', () => {
          thumbnailRender();
        });
        
        this.thumbnailInstance.init();

        if (this.numImages > this.thumbnailsView) {
          this.thumbnailInstance.controller.control = this.galleryInstance;
          this.galleryInstance.controller.control = this.thumbnailInstance;
        } else {
          thumbnailList.forEach((thumbnail) =>
            thumbnail.addEventListener('click', (event) => {
              event.preventDefault();
              const index = event.currentTarget.dataset.swiperSlideIndex;
              this.galleryInstance.slideToLoop(index);
              this.setActiveMediaSlider(index);
            })
          );
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveMediaSlider(index) {
        this.galleryInstance.slideToLoop(index);
        if (this.thumbnailInstance) this.setActiveThumbnail(index);
      }

      getGalleryInstance() {
        return this.galleryInstance;
      }

      // setActiveThumbnail(index) {
      //   if (this.numImages <= this.thumbnailsView) {
      //     this.thumbnail.querySelector('.swiper-slide-active').classList.remove('swiper-slide-active');
      //     this.thumbnail.querySelector(`[data-swiper-slide-index='${index}']`).classList.add('swiper-slide-active');
      //   }
      // }

      setActiveThumbnail(index) {
        if (this.numImages <= this.thumbnailsView) {
          const activeSlide = this.thumbnail.querySelector('.swiper-slide-active');
          const targetSlide = this.thumbnail.querySelector(`[data-swiper-slide-index='${index}']`);

          if (activeSlide) {
            activeSlide.classList.remove('swiper-slide-active');
          }

          if (targetSlide) {
            targetSlide.classList.add('swiper-slide-active');
          }
        }
      }


      playActiveMedia(activeItem) {
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          if (deferredMedia.tagName == 'PRODUCT-MODEL') this.galleryInstance.allowTouchMove = false;
          deferredMedia.loadContent(false);
        }
      }
    }
  );
}
